import React from 'react';
import styled from 'styled-components';
import Typography from '../../common/Typography';
import { formatCurrencyCents } from '../../../util/currency';

interface SubtotalProps extends React.HTMLAttributes<HTMLDivElement> {
  lineItems: {
    amount: number; // in cents
    label: string;
    id: string;
  }[];
  total: number; // in cents
}

const Container = styled.div``;

const LineItem = styled.div<{ $bold?: boolean; $justifyContent?: string }>`
  display: flex;
  ${(props) => `justify-content: ${props.$justifyContent || 'space-between'};`}
  ${(props) => props.$bold && 'font-weight: 600;'}
`;

const Total = styled.span`
  margin-right: 32px;
`;

const Hr = styled.hr`
  margin: 8px 0;
`;

const Subtotal: React.FC<SubtotalProps> = ({ lineItems, total, ...props }) => {
  return (
    <Container {...props}>
      <Typography
        as="p"
        fontSize="16px"
        variant="secondary"
        margin="24px 0 16px 0"
      >
        Summary of charges
      </Typography>
      {lineItems.map((item, i) => (
        <LineItem key={i}>
          <span>{item.label}</span>
          <span>{formatCurrencyCents(item.amount)}</span>
        </LineItem>
      ))}

      <Hr />

      <LineItem $bold $justifyContent="flex-end">
        <Total>Total</Total>
        <span>{formatCurrencyCents(total)}</span>
      </LineItem>
    </Container>
  );
};

export default Subtotal;
